/* EG Collections — Init (orchestrates modules; disables monolith via window.__egCollectionsSplitInit) */

(function () {

  function bindLegacyToggle(root) {
  if (!root || root.__egLegacyToggleBound) return;
  root.__egLegacyToggleBound = true;

  var btn = root.querySelector("[data-eg-legacy-toggle]");
  if (!btn) return;

  function isOn() {
    var sp = new URLSearchParams(window.location.search || "");
    return sp.get("eg_show_legacy") === "1";
  }

  function syncUi() {
    var on = isOn();
    btn.classList.toggle("is-on", on);
    btn.textContent = on ? "Hide legacy products" : "Show legacy products";
  }

  btn.addEventListener("click", function () {
    var u = new URL(window.location.href);

    if (u.searchParams.get("eg_show_legacy") === "1") {
      u.searchParams.delete("eg_show_legacy");
    } else {
      u.searchParams.set("eg_show_legacy", "1");
    }

    // Reset paging when toggling
    u.searchParams.delete("page");

    history.replaceState({}, "", u.toString());

    if (typeof egApplyPrettyUrlToAddressBar === "function") { try { egApplyPrettyUrlToAddressBar(); } catch (e3) {} }

    // Update button immediately
    syncUi();

    // Trigger a refresh/rerender (use whichever exists)
    if (typeof egCollectionsRefresh === "function") {
      egCollectionsRefresh(root);
    } else if (typeof egClientRenderRefresh === "function") {
      egClientRenderRefresh(root);
    } else if (typeof egClientRenderInit === "function") {
      // fallback: re-init client render (safe; guarded internally)
      egClientRenderInit(root);
    }
  });

  syncUi();
}

  function bindEgSort(root) {
    if (!root || root.__egSortBound) return;
    root.__egSortBound = true;

    function getActiveSort() {
      try {
        var sp = new URLSearchParams(window.location.search || "");
        return sp.get("eg_sort") || "featured";
      } catch (e) {
        return "featured";
      }
    }

    function applySelectedUi() {
      var active = getActiveSort();

      // Sort options may be teleported into the overlay panel (not nested under .eg-sort anymore)
      var btns = document.querySelectorAll('.eg-filter-option[data-eg-sort]');
      for (var i = 0; i < btns.length; i++) {
        var k = btns[i].getAttribute("data-eg-sort") || "";
        if ((active || "featured") === (k || "featured")) btns[i].classList.add("is-selected");
        else btns[i].classList.remove("is-selected");
      }

      // Active styling on the Sort GROUP (identical mechanism as other filters)
      var on = !!active && active !== "featured";

      // Sort group is inside root; the options panel may be teleported elsewhere
      var sortGrp = root.querySelector(".eg-filter-group.eg-sort");

      if (sortGrp) {
        sortGrp.classList.toggle("has-selection", on);

        // Match other filters: active class on the visible button element
        var sortTitle = sortGrp.querySelector(".eg-filter-title");
        if (sortTitle) sortTitle.classList.toggle("has-selection", on);
      }
    }

    function mapShopifyToEg(v) {
      v = String(v || "");
      if (v === "price-ascending") return "price_asc";
      if (v === "price-descending") return "price_desc";
      if (v === "title-ascending") return "title_asc";
      if (v === "title-descending") return "title_desc";
      if (v === "created-descending" || v === "date-descending") return "newest";
      return "featured";
    }

    function setEgSort(sortKey) {
      var url;
      try {
        url = new URL(window.location.href);
      } catch (e) {
        return;
      }

      var sp = url.searchParams;

      if (!sortKey || sortKey === "featured") sp.delete("eg_sort");
      else sp.set("eg_sort", sortKey);

      sp.delete("page");
      url.search = sp.toString();

      // Write the updated URL to the address bar (without reloading)
      try { history.replaceState({}, "", url.toString()); } catch (e2) {}

      if (typeof egApplyPrettyUrlToAddressBar === "function") {
        try { egApplyPrettyUrlToAddressBar(); } catch (e3) {}
      }

      applySelectedUi();

      if (root && typeof root.__egClientRenderRefresh === "function") {
        root.__egClientRenderRefresh();
      }

      if (root.__egUpdateAllCounts) root.__egUpdateAllCounts();
      if (root.__egUpdateClearVisibility) root.__egUpdateClearVisibility();
    }

    document.addEventListener("click", function (e) {
      // Sort options may be teleported into the overlay panel; do NOT require .eg-sort ancestry
      var btn =
        e.target.closest('.eg-filter-option[data-eg-sort]') ||
        e.target.closest('.value-picker__choice-item[data-action="select-value"][data-value]') ||
        e.target.closest('[data-action="select-value"][data-value]');

      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      var egKey = btn.getAttribute("data-eg-sort");
      if (!egKey) {
        var shopifyVal = btn.getAttribute("data-value") || "";
        egKey = mapShopifyToEg(shopifyVal);
      }

      setEgSort(egKey);
    }, true);

    // Allow other modules (pills) to resync Sort UI after URL changes
    root.__egSyncSortUi = applySelectedUi;

    applySelectedUi();
  }

  function renderEgSortOptions(root) {
    if (!root) return;

    var cfg = window.EG_COLLECTION_SORT_CONFIG;
    if (!cfg || !cfg.defaults || !cfg.defaults.options) return;

    var defaults = Array.isArray(cfg.defaults.options) ? cfg.defaults.options : [];

    var handle = (root.dataset && root.dataset.egCollection) ? String(root.dataset.egCollection) : "";
    var col = (cfg.collections && handle && cfg.collections[handle]) ? cfg.collections[handle] : null;

    // Collection options may contain only custom items OR a full list (including defaults).
    // We always show defaults first, then append any extra options not in defaults.
    var colOpts = (col && Array.isArray(col.options)) ? col.options : [];

    var defaultKeys = {};
    for (var d = 0; d < defaults.length; d++) {
      if (defaults[d] && defaults[d].key) defaultKeys[String(defaults[d].key)] = 1;
    }

    var extras = [];
    for (var c = 0; c < colOpts.length; c++) {
      var o = colOpts[c];
      if (!o || !o.key) continue;
      var k = String(o.key);
      if (!defaultKeys[k]) extras.push(o);
    }

    var host = root.querySelector('[data-eg-sort-options]');
    if (!host) return;

    var tpl = root.querySelector('#eg-sort-option-template');
    if (!tpl || !tpl.content) return;

    // Clear existing
    host.innerHTML = "";

    function appendOpt(opt) {
      if (!opt || !opt.key) return;

      var node = tpl.content.firstElementChild
        ? tpl.content.firstElementChild.cloneNode(true)
        : null;

      if (!node) return;

      node.setAttribute("data-eg-sort", String(opt.key));

      var labelEl = node.querySelector(".eg-filter-option-label");
      if (labelEl) labelEl.textContent = String(opt.label || opt.key);

      host.appendChild(node);
    }

    // 1) Defaults (always)
    for (var i = 0; i < defaults.length; i++) appendOpt(defaults[i]);

    // 2) Divider + extras (only if extras exist)
    if (extras.length) {
      var div = document.createElement("div");
      div.className = "eg-sort-divider";
      div.setAttribute("aria-hidden", "true");
      host.appendChild(div);

      for (var j = 0; j < extras.length; j++) appendOpt(extras[j]);
    }
  }

  function bindMobileFiltersSheet() {
    if (window.__egMobileSheetBound) return;
    window.__egMobileSheetBound = true;

    function open() { document.documentElement.classList.add("eg-mobile-filters-open"); }
    function close() { document.documentElement.classList.remove("eg-mobile-filters-open"); }

    document.addEventListener("click", function (e) {
      // Desktop: do nothing (prevents extra work on every click)
      try {
        if (!(window.matchMedia && window.matchMedia("(max-width: 999px)").matches)) return;
      } catch (err) { return; }

      var openBtn = e.target.closest && e.target.closest("[data-eg-mobile-filters-open]");
      if (openBtn) { e.preventDefault(); open(); return; }

      var closeBtn = e.target.closest && e.target.closest("[data-eg-mobile-filters-close]");
      if (closeBtn) { e.preventDefault(); close(); return; }

      var see = e.target.closest && e.target.closest("[data-eg-mobile-see-products]");
      if (see) { e.preventDefault(); close(); return; }
    }, true);
  }

  async function init() {
    const root = document.getElementById("eg-collection-filters");
    if (!root) return;

    bindMobileFiltersSheet();

    // Build EG sort options from config (custom tag sorts etc.)
    renderEgSortOptions(root);

    document.documentElement.classList.add("eg-collection-loading");
    var egStartedClient = false;

    try {
      if (typeof applyCollectionFilterConfig === "function") {
        applyCollectionFilterConfig(root);
      }

      if (typeof renderTagGroups === "function") {
        renderTagGroups(root);

        // IMPORTANT: re-apply ordering now that tag groups exist
        if (typeof applyCollectionFilterConfig === "function") {
          applyCollectionFilterConfig(root);
        }
      }
      
      if (typeof bindDropdownOverlay === "function") bindDropdownOverlay(root);
      if (typeof bindMobileFiltersDrawer === "function") bindMobileFiltersDrawer(root);
      if (typeof bindPriceRangeNavigation === "function") bindPriceRangeNavigation(root);
      if (typeof bindClearFilters === "function") bindClearFilters(root);
      if (typeof bindPillMoreWrapper === "function") bindPillMoreWrapper(root);
      if (typeof bindEgSort === "function") bindEgSort(root);

      bindLegacyToggle(root);

      // Client-render must be started AFTER all helpers/UI exist
      if (typeof egClientRenderInit === "function") {
        window.EG_CLIENT_RENDER_ADVERTS = true;

      const ok = egClientRenderInit(root);
      if (ok) { egStartedClient = true; return; }
      }

      } finally {
        if (!egStartedClient) {
          document.documentElement.classList.remove("eg-collection-loading");
        }
      }
  }

  // Signal to the old monolith to not run (we'll add the guard next)
  window.__egCollectionsSplitInit = true;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
